import type {ReactElement} from 'react';
import React from 'react';
import {ControlItems} from '@Components/contextual-menu/components/control-items';
import styles from './controls.module.scss';

export interface ControlsProps {
  className?: string;
  isCenterAligned?: boolean;
  items: BaseControlItem[];
  itemsClassName?: string;
  wrapItems?: boolean;
  onClick?(id: string): void;
}

export interface BaseControlItem {
  id: string;
  disabled?: boolean;
  className?: string;
  text?: string;
  icon: string;
  iconClasses?: string;
  textClasses?: string;
  wrapText?: boolean;
  hasCustomColor?: boolean;
  isSelected?: boolean;
  shouldShowToolTip?: boolean;
  tooltipText?: string;
  toolTipHideDelay?: number;
  showAsNewFeature?: boolean;

  onClick?(id: string): void;
}

export function Controls({isCenterAligned = false, itemsClassName = '', className = '', wrapItems = false, onClick = (): void => {}, ...props}: ControlsProps): ReactElement<any> {
  const getControlItems = (): ReactElement<any>[] => {
    return props.items.map((controlItems) => {
      return (
        <ControlItems
          key={controlItems.id}
          {...controlItems}
          isDisabled={controlItems.disabled}
          text={controlItems.text}
          onClick={(id): void => {
            if (controlItems.onClick) {
              controlItems.onClick(id);
            }
            onClickHandler(controlItems.id);
          }}
          className={`${itemsClassName} ${controlItems.className ? controlItems.className : ''} `}
          iconClasses={controlItems.iconClasses}
          textClasses={controlItems.textClasses}
          wrapText={controlItems.wrapText}
          hasCustomColor={controlItems.hasCustomColor}
          toolTipHideDelay={controlItems.toolTipHideDelay}
        />
      );
    });
  };

  const onClickHandler = (id: string): void => {
    onClick(id);
  };

  return (
    <ul className={`flexbox ${className} ${styles.container} ${wrapItems ? styles.flexWrap : ''} ${isCenterAligned ? styles.centerAlignedContainer : ''}`}>{getControlItems()}</ul>
  );
}
